import Vue from "vue";
import Router from "vue-router";
import * as Sentry from "@sentry/vue";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";
import Blog_HowToHideApiKey from "./views/Blog_HowToHideApiKey.vue";
import Blog_GettingStarted from "./views/Blog_GettingStarted.vue";
import Blog_HideApiKeyFromGitHub from "./views/Blog_HideApiKeyFromGitHub.vue";
import Blog_WhatIsARelayServer from "./views/Blog_WhatIsARelayServer.vue";

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/howtohideapikey",
      name: "Blog > How to hide your API key",
      components: {
        header: AppHeader,
        default: Blog_HowToHideApiKey,
        footer: AppFooter
      }
    },
    {
      path: "/getting-started",
      name: "Blog > Getting Started",
      components: {
        header: AppHeader,
        default: Blog_GettingStarted,
        footer: AppFooter
      }
    },/*
    {
      path: "/hide-api-key-from-github",
      name: "Blog > Hide API key from GitHub",
      components: {
        header: AppHeader,
        default: Blog_HideApiKeyFromGitHub,
        footer: AppFooter
      }
    },*/
    /*
    {
      path: "/what-is-a-relay-server",
      name: "Blog > What is a relay server",
      components: {
        header: AppHeader,
        default: Blog_WhatIsARelayServer,
        footer: AppFooter
      }
    },*/
    {
      path: "/hide-google-maps-api-key",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/hide-pexels-api-key",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/hide-pixabay-api-key",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/login",
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      }
    },
    {
      path: "/register",
      name: "register",
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter
      }
    },
    {
      path: "/profile",
      name: "profile",
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
